module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("FcpeO"))).then(() => parcelRequire('hEqeo'));